import { OrderRejectionReason } from '../../../../../../../services/exports/Constants';

export default {
  statuses: {
    rejected: 'Cancelado: {{reason}}',
    fulfilled: 'Este pedido se completó correctamente',
  },
  rejection_reasons: {
    [OrderRejectionReason.Automatic]: 'No aceptado',
    [OrderRejectionReason.ClosingSoon]: 'Cierre próximo',
    [OrderRejectionReason.ItemUnavailable]: 'Artículo no disponible',
    [OrderRejectionReason.OrderTooBig]: 'Pedido demasiado grande',
    [OrderRejectionReason.CustomerMistake]: 'Error del cliente',
    [OrderRejectionReason.Other]: 'Otro',
    fully_refunded: 'El pedido fue completamente reembolsado',
  },
};
